// 移除对服务层临时数据API的依赖，统一使用基于sessionStorage的实现
import formDataStorage from './formDataStorage';

// 简单日期工具：将 y/m/d 组装为 Date；任一缺失返回 null
const mkDate = (y, m, d) => {
  if (!y || !m || !d) return null;
  const yy = parseInt(y, 10);
  // 月份既可能是 '01'..'12' 也可能是 'JAN'..'DEC'（极少数表单）
  const MONTH_MAP = { JAN:1, FEB:2, MAR:3, APR:4, MAY:5, JUN:6, JUL:7, AUG:8, SEP:9, OCT:10, NOV:11, DEC:12 };
  let mm;
  if (typeof m === 'string' && MONTH_MAP[m.toUpperCase()]) {
    mm = MONTH_MAP[m.toUpperCase()];
  } else {
    mm = parseInt(m, 10);
  }
  const dd = parseInt(d, 10);
  if (!yy || !mm || !dd) return null;
  try {
    return new Date(yy, mm - 1, dd);
  } catch (e) {
    return null;
  }
};

// 表单验证工具集合
export const formValidators = {
  
  // 个人信息1验证
  personal_1: (data) => {
    const missing = []
    
    // 检查基本字段
    if (!data.surnames) missing.push('英文姓氏');
    if (!data.given_name) missing.push('英文名字');
    if (!data.full_name) missing.push('中文全名');
    if (!data.sex) missing.push('性别');
    if (!data.marital_status) missing.push('婚姻状况');
    
    // 检查出生日期
    const birthData = data.date_and_place_of_birth || {};
    if (!birthData.year || !birthData.month || !birthData.day) {
      missing.push('出生日期');
    } else {
      // 验证出生日期不能是今天或之后
      const MONTHS = [
        { value: 'JAN', label: '01月 (JAN)' },
        { value: 'FEB', label: '02月 (FEB)' },
        { value: 'MAR', label: '03月 (MAR)' },
        { value: 'APR', label: '04月 (APR)' },
        { value: 'MAY', label: '05月 (MAY)' },
        { value: 'JUN', label: '06月 (JUN)' },
        { value: 'JUL', label: '07月 (JUL)' },
        { value: 'AUG', label: '08月 (AUG)' },
        { value: 'SEP', label: '09月 (SEP)' },
        { value: 'OCT', label: '10月 (OCT)' },
        { value: 'NOV', label: '11月 (NOV)' },
        { value: 'DEC', label: '12月 (DEC)' }
      ];
      
      const birthDate = new Date(birthData.year, MONTHS.findIndex(m => m.value === birthData.month), parseInt(birthData.day));
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      
      if (birthDate >= today) {
        missing.push('出生日期不能是今天或之后的日期');
      }
    }
    
    if (!birthData.city) missing.push('出生城市');
    if (!birthData.state_or_province) missing.push('出生省份/州');
    if (!birthData.country) missing.push('出生国家');
    
    // 检查别名
    if (data.has_other_name && (!data.other_names || data.other_names.length === 0)) {
      missing.push('别名信息');
    }
    
    // 检查电码名字
    if (data.has_telecode_name) {
      const telecodeName = data.telecode_name || {};
      if (!telecodeName.surnames || !telecodeName.given_name) {
        missing.push('电码名字');
      }
    }
    
    return {
      isValid: missing.length === 0,
      errors: missing.map(field => `请填写${field}`)
    };
  },

  // 个人信息2验证
  personal_2: (data) => {
    const missing = [];
    if (!data.country) missing.push('国籍');
    if (!data.national_id_not_applicable && !data.national_identification_number) missing.push("身份证号");
    return {
      isValid: missing.length === 0,
      errors: missing.map(field => `请填写${field}`)
    };
  },

  // 旅行信息验证
  travel: (data) => {
    const missing = [];
    const errorDetails = [];
    
    // 验证旅行目的（确保至少有一个已填写的目的）
    const purposes = data.purpose || [];
    if (purposes.length === 0) {
      missing.push('旅行目的');
    } else {
      const hasValidPurpose = purposes.some(purpose => purpose.main_type && purpose.sub_type);
      if (!hasValidPurpose) {
        missing.push('旅行目的');
      }
      
      // 验证F2家属签证主申请人信息（只在选择了F2签证类型时验证）
      const hasF2Visa = purposes.some(purpose => 
        purpose.sub_type === 'F2-CH' || purpose.sub_type === 'F2-SP'
      );
      if (hasF2Visa) {
        // 只有在明确选择了F2签证类型时才验证主申请人信息
        if (!data.principal_applicant_surnames) {
          missing.push('主申请人姓氏');
        }
        if (!data.principal_applicant_given_name) {
          missing.push('主申请人名字');
        }
        
        // 验证字符长度限制
        if (data.principal_applicant_surnames && data.principal_applicant_surnames.length > 33) {
          missing.push('主申请人姓氏不能超过33个字符');
        }
        if (data.principal_applicant_given_name && data.principal_applicant_given_name.length > 33) {
          missing.push('主申请人名字不能超过33个字符');
        }
      }
    }
    
    if (!data.arrival_year || !data.arrival_month || !data.arrival_day) missing.push('到达日期');
    if ((!data.stay_duration || !data.stay_duration_unit) && !data.has_specific_plan) missing.push('停留时间');
    if (!data.finance) missing.push('费用支付方式');
    if (!data.us_state) { errorDetails.push({ message: '请选择美国州', anchor: '#us_addr_state' }); }
    if (!data.us_zip_code) { errorDetails.push({ message: '请填写美国邮政编码', anchor: '#us_addr_zip' }); }
    if (!data.us_street_address1 || !data.us_city || !data.us_state) missing.push('美国地址信息');
    
    // 验证邮政编码格式（当选择中国大陆时）
    if (data.payer_country === 'CHIN') {
      // 验证资助人地址邮政编码
      if (data.payer_zip_code && !/^\d{6}$/.test(data.payer_zip_code)) {
        const msg = '资助人地址邮政编码格式不正确（应为6位数字）';
        missing.push(msg);
        errorDetails.push({ message: msg, anchor: '#payer_zip_code' });
      }
      // 验证其他公司/组织支付地址邮政编码
      if (data.other_payer_zip_code && !/^\d{6}$/.test(data.other_payer_zip_code)) {
        missing.push('其他公司/组织支付地址邮政编码格式不正确（应为6位数字）');
      }
    }

    // 资助人邮箱格式校验（仅在 finance 为个人且填写时）
    if (data.finance === 'O' && data.email) {
      const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (!emailRegex.test(data.email)) {
        const msg = '电子邮箱格式不正确（如：example@email.com）';
        // 不加入 missing 的“请填写X”格式，直接放入错误细节供定位
        errorDetails.push({ message: msg, anchor: '#payer_email' });
      }
    }
    
    // 验证到达日期（无论是否有具体计划）
    if (!data.arrival_year || !data.arrival_month || !data.arrival_day) {
      missing.push('到达日期');
    } else {
      const arrivalDate = new Date(data.arrival_year, data.arrival_month - 1, data.arrival_day);
      const today = new Date();
      today.setHours(0, 0, 0, 0); // 重置时间为当天开始
      
      // 放宽日期验证：允许今天和未来的日期
      if (arrivalDate < today) {
        missing.push('到达日期不能是过去的日期');
      }
    }
    
    // 验证离开日期（只在有具体计划时）
    if (data.has_specific_plan) {
      if (!data.departure_year || !data.departure_month || !data.departure_day) {
        missing.push('离开日期');
      } else {
        const departureDate = new Date(data.departure_year, data.departure_month - 1, data.departure_day);
        
        // 如果到达日期也有效，验证日期顺序
        if (data.arrival_year && data.arrival_month && data.arrival_day) {
          const arrivalDate = new Date(data.arrival_year, data.arrival_month - 1, data.arrival_day);
          
          if (departureDate <= arrivalDate) {
            const msg = '离开日期必须在到达日期之后';
            missing.push(msg);
            errorDetails.push({ message: msg, anchor: '#travel_departure_year' });
          }
        }
      }
    }
    // 将 arrival 日期基础问题也加上锚点（提示到 arrival 年份）
    const errs = missing.map(field => `请填写${field}`);
    if (!data.arrival_year || !data.arrival_month || !data.arrival_day) {
      errorDetails.push({ message: '请填写到达日期', anchor: '#travel_arrival_year' });
    }
    return {
      isValid: errs.length === 0,
      errors: errs,
      errorDetails
    };
  },

  // 旅行伙伴信息验证
  travel_companions_info: (data) => {
    if (!data.travel_companions) return { isValid: true, errors: [] };
    
    if (data.group_travel) {
      // 跟随团体时只需验证团体名称
      return {
        isValid: !!data.group_name,
        errors: !data.group_name ? ['请填写团体或组织名称'] : []
      };
    } else {
      // 个人同行时需验证每个同行人员信息
      const personInfo = data.person_info || [];
      if (personInfo.length === 0) {
        return { isValid: false, errors: ['请添加至少一个同行人员信息'] };
      }
      
      const errors = [];
      personInfo.forEach((person, index) => {
        if (!person.surnames) errors.push(`同行人员${index + 1}: 请填写姓氏`);
        if (!person.given_name) errors.push(`同行人员${index + 1}: 请填写名字`);
        if (!person.relationship) errors.push(`同行人员${index + 1}: 请选择关系`);
      });
      
      return { isValid: errors.length === 0, errors };
    }
  },

  // 美国旅行历史验证
  previous_US_travel_info: (data) => {
    const errors = [];
    const errorDetails = [];
    
    // 如果访问过美国，需要验证访问记录
    if (data.have_ever_been_in_us) {
      const visitInfo = data.visit_info || [];
      if (visitInfo.length === 0) {
        errors.push('请添加至少一个访问记录');
      } else {
        visitInfo.forEach((visit, index) => {
          if (!visit.year) { const msg = `访问记录${index + 1}: 请填写年份`; errors.push(msg); errorDetails.push({ message: msg, anchor: `#prev_visit_${index}_year`}); }
          if (!visit.month) { errors.push(`访问记录${index + 1}: 请选择月份`); }
          if (!visit.day) { errors.push(`访问记录${index + 1}: 请选择日期`); }
          if (!visit.lenth_of_stay) errors.push(`访问记录${index + 1}: 请填写停留天数`);
          if (!visit.lenth_unit) errors.push(`访问记录${index + 1}: 请选择时间单位`);
        });
      }
      
      // 如果持有过驾照，需要验证驾照信息
      if (data.ever_hold_driver_license) {
        const licenses = data.driver_license || [];
        if (licenses.length === 0) {
          errors.push('请添加至少一个驾照信息');
        } else {
          licenses.forEach((license, index) => {
            if (!license.number) { const msg = `驾照${index + 1}: 请填写驾照号码`; errors.push(msg); errorDetails.push({ message: msg, anchor: `#driver_${index}_number`}); }
            if (!license.state) { const msg = `驾照${index + 1}: 请选择签发州`; errors.push(msg); errorDetails.push({ message: msg, anchor: `#driver_${index}_state`}); }
          });
        }
      }
    }
    
    // 如果被签发过签证，需要验证签证信息
    if (data.ever_been_issued_visa) {
      const lastVisa = data.last_visa || {};
      if (!lastVisa.issued_year) errors.push('请填写签证签发年份');
      if (!lastVisa.issued_month) errors.push('请选择签证签发月份');
      if (!lastVisa.issued_day) errors.push('请选择签证签发日期');
      if (!lastVisa.visa_number) errors.push('请填写签证号码');
    }
    
    // 如果被拒绝过签证，需要填写原因
    if (data.visa_refused && !data.visa_refused_reason) {
      errors.push('请填写签证被拒绝的原因');
    }
    
    // 如果被拒签过签证，需要填写原因
    if (data.visa_denial && !data.visa_denial_reason) {
      errors.push('请填写签证被拒签的原因');
    }
    
    // 如果有移民申请，需要填写详情
    if (data.has_petition && !data.petition_reason) {
      errors.push('请填写移民申请详情');
    }
    
    return { isValid: errors.length === 0, errors, errorDetails };
  },
  // 地址电话信息验证
  address_phone: (data) => {
    const errors = [];
    const errorDetails = [];
    
    // 验证家庭地址
    const homeAddress = data.home_address || {};
    if (!homeAddress.street_address) errors.push('请填写家庭地址街道地址');
    if (!homeAddress.city) errors.push('请填写家庭地址城市');
    if (!homeAddress.state) errors.push('请填写家庭地址州/省');
    if (!homeAddress.zip_code) errors.push('请填写家庭地址邮政编码');
    if (!homeAddress.country) errors.push('请选择家庭地址国家');
    
    // 验证邮寄地址（如果不同于家庭地址）
    if (data.mailing_address_same === false) {
      const mailingAddress = data.mailing_address || {};
      if (!mailingAddress.street_address) { const msg='请填写邮寄地址街道地址'; errors.push(msg); errorDetails.push({ message: msg, anchor: '#mailing_street1' }); }
      if (!mailingAddress.country) { const msg='请选择邮寄地址国家'; errors.push(msg); errorDetails.push({ message: msg, anchor: '#mailing_country' }); }
      if (!mailingAddress.state) { const msg='请填写邮寄地址州/省'; errors.push(msg); errorDetails.push({ message: msg, anchor: '#mailing_state' }); }
      if (!mailingAddress.city) { const msg='请填写邮寄地址城市'; errors.push(msg); errorDetails.push({ message: msg, anchor: '#mailing_city' }); }
      if (!mailingAddress.zip_code) { const msg='请填写邮寄地址邮政编码'; errors.push(msg); errorDetails.push({ message: msg, anchor: '#mailing_zip' }); }
    }
    
    // 验证电话信息
    if (!data.primary_phone) { const msg='请填写主要电话号码'; errors.push(msg); errorDetails.push({ message: msg, anchor: '#home_primary_phone' }); }
    
    // 验证其他电话（如果选择了使用其他电话）
    if (data.other_phone_used) {
      const otherPhones = data.other_phone || [];
      if (otherPhones.length === 0) {
        errors.push('请添加至少一个其他电话号码');
      } else {
        otherPhones.forEach((phone, index) => {
          if (!phone) errors.push(`其他电话${index + 1}: 请填写电话号码`);
        });
      }
    }
    
    // 验证邮箱信息
    if (!data.email) { const msg='请填写主要邮箱地址'; errors.push(msg); errorDetails.push({ message: msg, anchor: '#home_email' }); }
    
    // 验证其他邮箱（如果选择了使用其他邮箱）
    if (data.other_email_used) {
      const otherEmails = data.other_email || [];
      if (otherEmails.length === 0) {
        errors.push('请添加至少一个其他邮箱地址');
      } else {
        otherEmails.forEach((email, index) => {
          if (!email) errors.push(`其他邮箱${index + 1}: 请填写邮箱地址`);
        });
      }
    }
    
    // 验证社交媒体信息
    const socialMedia = data.social_media || [];
    socialMedia.forEach((social, index) => {
      if (social.social_media && !social.social_media_identifier) {
        errors.push(`社交媒体${index + 1}: 请填写账号标识`);
      }
      if (!social.social_media && social.social_media_identifier) {
        errors.push(`社交媒体${index + 1}: 请选择社交媒体平台`);
      }
    });
    
    // 验证共享社交媒体信息（如果选择了共享）
    if (Array.isArray(data.share_social_media)) {
      data.share_social_media.forEach((social, index) => {
        if (social.social_media && !social.social_media_identifier) {
          errors.push(`共享社交媒体${index + 1}: 请填写账号标识`);
        }
        if (!social.social_media && social.social_media_identifier) {
          errors.push(`共享社交媒体${index + 1}: 请选择社交媒体平台`);
        }
      });
    }
    
    return { isValid: errors.length === 0, errors };
  },
  // 护照签证信息验证
  passport_visa: (data) => {
    const errors = [];
    const errorDetails = [];
    
    // 验证护照基本信息
    if (!data.ppt_type) errors.push('请选择护照类型');
    if (!data.ppt_number) errors.push('请填写护照号码');
    
    // 验证护照类型说明（只有T类型需要说明）
    if (data.ppt_type === 'T' && !data.ppt_explain) {
      errors.push('请填写护照类型说明（其他类型详情）');
    }
    
    // 验证护照签发信息
    if (!data.ppt_issued_country) errors.push('请选择护照签发国家');
    if (!data.ppt_issued_city) errors.push('请填写护照签发城市');
    if (!data.ppt_issued_year) errors.push('请填写护照签发年份');
    if (!data.ppt_issued_month) errors.push('请选择护照签发月份');
    if (!data.ppt_issued_day) errors.push('请选择护照签发日期');
    
    // 验证护照到期信息（如果有到期日期）
    if (data.has_ppt_expiration) {
      if (!data.ppt_expired_year) errors.push('请填写护照到期年份');
      if (!data.ppt_expired_month) errors.push('请选择护照到期月份');
      if (!data.ppt_expired_day) errors.push('请选择护照到期日期');
    }

    // 日期先后关系（P0）：到期 >= 签发；签发 <= 今天
    const issued = mkDate(data.ppt_issued_year, data.ppt_issued_month, data.ppt_issued_day);
    if (issued) {
      const today = new Date(); today.setHours(0,0,0,0);
      if (issued > today) {
        const msg = '护照签发日期不能晚于今天';
        errors.push(msg);
        errorDetails.push({ message: msg, anchor: '#ppt_issued_year' });
      }
    }
    if (data.has_ppt_expiration) {
      const expired = mkDate(data.ppt_expired_year, data.ppt_expired_month, data.ppt_expired_day);
      if (issued && expired && expired < issued) {
        const msg = '护照到期日期不能早于签发日期';
        errors.push(msg);
        errorDetails.push({ message: msg, anchor: '#ppt_expired_year' });
      }
    }
    
    // 验证丢失护照信息（如果有丢失护照）
    if (data.ppt_lost) {
      const lostPassports = data.lost_ppt || [];
      if (lostPassports.length === 0) {
        errors.push('请添加至少一个丢失护照记录');
      } else {
        lostPassports.forEach((passport, index) => {
          if (!passport.lost_ppt_number) {
            const msg = `丢失护照${index + 1}: 请填写护照号码`;
            errors.push(msg);
            errorDetails.push({ message: msg, anchor: `#lost_ppt_${index}_number` });
          }
          if (!passport.lost_ppt_country) {
            const msg = `丢失护照${index + 1}: 请选择签发国家`;
            errors.push(msg);
            errorDetails.push({ message: msg, anchor: `#lost_ppt_${index}_country` });
          }
          if (!passport.explain) errors.push(`丢失护照${index + 1}: 请填写丢失说明`);
        });
      }
    }
    
    return { isValid: errors.length === 0, errors, errorDetails };
  },
  // 美国联系人信息验证
  us_contact: (data) => {
    const errors = [];
    const errorDetails = [];
    // 验证联系人信息（个人信息和组织信息二选一）
    const hasPersonInfo = !data.contact_person_na;
    const hasOrgInfo = !data.contact_orgnization_na;
    
    if (!hasPersonInfo && !hasOrgInfo) {
      const msg = '请选择联系人个人信息或组织信息（二选一）';
      errors.push(msg);
      errorDetails.push({ message: msg, anchor: '#us_contact_city' });
    }
    
    // 验证联系人个人信息（如果选择）
    if (hasPersonInfo) {
      const contactPerson = data.contact_person || {};
      if (!contactPerson.contact_surnames) errors.push('请填写联系人姓氏');
      if (!contactPerson.contact_given_name) errors.push('请填写联系人名字');
    }
    
    // 验证联系人组织信息（如果选择）
    if (hasOrgInfo) {
      const contactOrganization = data.contact_organization || {};
      if (!contactOrganization.contact_organization_name) errors.push('请填写组织名称');
    }
    
    // 验证关系
    if (!data.relationship) errors.push('请选择与申请人的关系');
    
    // 验证地址和电话信息
    const addressAndPhone = data.address_and_phone || {};
    if (!addressAndPhone.address_ln1) errors.push('请填写地址第一行');
    if (!addressAndPhone.city) errors.push('请填写城市');
    if (!addressAndPhone.state) { const msg = '请选择州'; errors.push(msg); errorDetails.push({ message: msg, anchor: '#us_contact_state' }); }
    if (!addressAndPhone.postal_code) { const msg = '请填写邮政编码'; errors.push(msg); errorDetails.push({ message: msg, anchor: '#us_contact_postal' }); }
    if (!addressAndPhone.phone_number) errors.push('请填写电话号码');
    
    // 验证邮箱信息（如果不是不适用）
    if (!addressAndPhone.email_address_na && !addressAndPhone.email_address) {
      const msg = '请填写邮箱地址';
      errors.push(msg);
      errorDetails.push({ message: msg, anchor: '#us_contact_email' });
    }
    // NA 冲突（若 NA 选中但仍填入邮箱）
    if (addressAndPhone.email_address_na && addressAndPhone.email_address) {
      const msg = '已选择不适用，但邮箱仍有值；请清空邮箱或取消不适用';
      errors.push(msg);
      errorDetails.push({ message: msg, anchor: '#us_contact_email' });
    }
    return { isValid: errors.length === 0, errors, errorDetails };
  },
  // 家庭信息验证
  family_info: (data) => {
    const errors = [];
    const errorDetails = [];
    
    // 获取Personal1Form的数据以检查婚姻状况
    const maritalStatus = data.marital_status;
    
    // 验证父亲信息
    if (!data.father_surnames_unk_ind && !data.father_surnames) {
      errors.push('请填写父亲姓氏或选择"不知道"');
    }
    if (!data.father_given_name_unk_ind && !data.father_given_name) {
      errors.push('请填写父亲名字或选择"不知道"');
    }
    
    // 验证父亲出生日期（如果不是未知）
    if (!data.father_dob_unk_ind) {
      const fatherBirthDate = data.father_birth_date || {};
      if (!fatherBirthDate.year) errors.push('请填写父亲出生年份');
      if (!fatherBirthDate.month) errors.push('请选择父亲出生月份');
      if (!fatherBirthDate.day) errors.push('请选择父亲出生日期');
    }
    
    // 验证父亲是否居住在美国的选择
    if (data.father_live_in_us_ind === undefined) {
      errors.push('请选择父亲是否居住在美国');
    }
    
    // 验证父亲美国身份状态（如果居住在美国）
    if (data.father_live_in_us_ind && !data.if_father_in_us_status) {
      errors.push('请选择父亲在美国的身份状态');
    }
    
    // 验证母亲信息
    if (!data.mother_surnames_unk_ind && !data.mother_surnames) {
      errors.push('请填写母亲姓氏或选择"不知道"');
    }
    if (!data.mother_given_name_unk_ind && !data.mother_given_name) {
      errors.push('请填写母亲名字或选择"不知道"');
    }
    
    // 验证母亲出生日期（如果不是未知）
    if (!data.mother_dob_unk_ind) {
      const motherBirthDate = data.mother_birth_date || {};
      if (!motherBirthDate.year) errors.push('请填写母亲出生年份');
      if (!motherBirthDate.month) errors.push('请选择母亲出生月份');
      if (!motherBirthDate.day) errors.push('请选择母亲出生日期');
    }
    
    // 验证母亲是否居住在美国的选择
    if (data.mother_live_in_us_ind === undefined) {
      errors.push('请选择母亲是否居住在美国');
    }
    
    // 验证母亲美国身份状态（如果居住在美国）
    if (data.mother_live_in_us_ind && !data.if_mother_in_us_status) {
      errors.push('请选择母亲在美国的身份状态');
    }
    
    // 验证其他美国亲属信息
    if (data.us_immed_relative_ind === undefined) {
      errors.push('请选择是否有其他直系亲属在美国');
    }
    
    // 验证其他亲属信息
    if (data.us_other_relative_ind === undefined) {
      errors.push('请选择是否有其他亲属在美国');
    }
    
    // 验证配偶信息（如果需要）
    const needSpouseInfo = ['M', 'C', 'P', 'L'].includes(maritalStatus);
    if (needSpouseInfo) {
      if (!data.spouse_surnames) errors.push('请填写配偶姓氏');
      if (!data.spouse_given_name) errors.push('请填写配偶名字');
      
      // 验证配偶出生日期（如果不是未知）
      if (!data.spouse_dob_unk_ind) {
        const spouseBirthDate = data.spouse_birth_date || {};
        if (!spouseBirthDate.year) errors.push('请填写配偶出生年份');
        if (!spouseBirthDate.month) errors.push('请选择配偶出生月份');
        if (!spouseBirthDate.day) errors.push('请选择配偶出生日期');
      }
      
      if (!data.spouse_nationality) errors.push('请选择配偶国籍');
      if (!data.spouse_pob_country) errors.push('请选择配偶出生国家');
      
      // 验证配偶出生城市（如果不是未知）
      if (!data.spouse_pob_city_unk_ind && !data.spouse_pob_city) {
        errors.push('请填写配偶出生城市或选择"不知道"');
      }
      
      // 验证配偶地址类型
      if (!data.spouse_address_type) {
        errors.push('请选择配偶地址类型');
      }
      
      // 如果选择"其他"地址类型，验证具体地址
      if (data.spouse_address_type === 'O') {
        const spouseAddress = data.spouse_address || {};
        if (!spouseAddress.street_address) errors.push('请填写配偶街道地址');
        if (!spouseAddress.city) errors.push('请填写配偶居住城市');
        if (!spouseAddress.country) errors.push('请选择配偶居住国家');
      }
      
      // 验证配偶是否居住在美国的选择
      if (data.spouse_live_in_us_ind === undefined) {
        errors.push('请选择配偶是否居住在美国');
      }
      
      // 验证配偶美国身份状态（如果居住在美国）
      if (data.spouse_live_in_us_ind && !data.if_spouse_in_us_status) {
        errors.push('请选择配偶在美国的身份状态');
      }
    }
    
    // 验证前配偶信息（如果需要）
    const needFormerSpouseInfo = maritalStatus === 'D';
    if (needFormerSpouseInfo) {
      if (!data.number_of_former_spouses || parseInt(data.number_of_former_spouses) < 1) {
        errors.push('请填写前配偶数量');
      } else {
        const formerSpousesCount = parseInt(data.number_of_former_spouses);
        const formerSpouses = data.former_spouses || [];
        
        if (formerSpouses.length < formerSpousesCount) {
          errors.push(`请添加 ${formerSpousesCount} 位前配偶的信息`);
        }
        
        // 验证每位前配偶的信息
        formerSpouses.forEach((spouse, index) => {
          if (!spouse.surnames) errors.push(`请填写前配偶 #${index + 1} 的姓氏`);
          if (!spouse.given_name) errors.push(`请填写前配偶 #${index + 1} 的名字`);
          if (!spouse.nationality) errors.push(`请选择前配偶 #${index + 1} 的国籍`);
          if (!spouse.pob_country) errors.push(`请选择前配偶 #${index + 1} 的出生国家`);
          if (!spouse.marriage_end_country) errors.push(`请选择前配偶 #${index + 1} 的婚姻结束国家`);
          if (!spouse.how_marriage_ended) errors.push(`请填写前配偶 #${index + 1} 的婚姻结束方式`);
          
          // 验证出生日期
          const birthDate = spouse.birth_date || {};
          if (!birthDate.year) errors.push(`请填写前配偶 #${index + 1} 的出生年份`);
          if (!birthDate.month) errors.push(`请选择前配偶 #${index + 1} 的出生月份`);
          if (!birthDate.day) errors.push(`请选择前配偶 #${index + 1} 的出生日期`);
          
          // 验证结婚日期
          const marriageDate = spouse.marriage_date || {};
          if (!marriageDate.year) errors.push(`请填写前配偶 #${index + 1} 的结婚年份`);
          if (!marriageDate.month) errors.push(`请选择前配偶 #${index + 1} 的结婚月份`);
          if (!marriageDate.day) errors.push(`请选择前配偶 #${index + 1} 的结婚日期`);
          
          // 验证婚姻结束日期
          const endDate = spouse.marriage_end_date || {};
          if (!endDate.year) errors.push(`请填写前配偶 #${index + 1} 的婚姻结束年份`);
          if (!endDate.month) errors.push(`请选择前配偶 #${index + 1} 的婚姻结束月份`);
          if (!endDate.day) errors.push(`请选择前配偶 #${index + 1} 的婚姻结束日期`);

          // 日期先后（P0）：结束 > 结婚
          const md = mkDate(marriageDate.year, marriageDate.month, marriageDate.day);
          const ed = mkDate(endDate.year, endDate.month, endDate.day);
          if (md && ed && ed <= md) {
            const msg = `前配偶 #${index + 1}: 婚姻结束日期必须晚于结婚日期`;
            errors.push(msg);
            errorDetails.push({ message: msg, anchor: `#former_spouse_${index}_marriage_end_date_year` });
          }
        });
      }
    }
    
    // 验证已故配偶信息（如果需要）
    const needDeceasedSpouseInfo = maritalStatus === 'W';
    if (needDeceasedSpouseInfo) {
      if (!data.deceased_spouse_surnames) errors.push('请填写已故配偶姓氏');
      if (!data.deceased_spouse_given_name) errors.push('请填写已故配偶名字');
      
      // 验证已故配偶出生日期
      const deceasedSpouseBirthDate = data.deceased_spouse_birth_date || {};
      if (!deceasedSpouseBirthDate.year) errors.push('请填写已故配偶出生年份');
      if (!deceasedSpouseBirthDate.month) errors.push('请选择已故配偶出生月份');
      if (!deceasedSpouseBirthDate.day) errors.push('请选择已故配偶出生日期');
      
      if (!data.deceased_spouse_nationality) errors.push('请选择已故配偶国籍');
      if (!data.deceased_spouse_pob_city) errors.push('请填写已故配偶出生城市');
      if (!data.deceased_spouse_pob_country) errors.push('请选择已故配偶出生国家');
    }
    
    return { isValid: errors.length === 0, errors, errorDetails };
  },
  // 工作教育验证
  work_education: (data) => {
    const errors = [];
    const errorDetails = [];
    
    // 验证主要职业
    if (!data.primary_occupation) errors.push('请选择主要职业');
    
    // 如果选择退休或家庭主妇，只需要验证职业选择
    if (data.primary_occupation === 'RT' || data.primary_occupation === 'H') {
      return {
        isValid: errors.length === 0,
        errors
      };
    }
    
    // 验证职业类型说明（选择OTHER或NOT EMPLOYED时需要）
    if (data.primary_occupation === 'O' || data.primary_occupation === 'N') {
      if (!data.primary_occupation_explain) {
        const explainType = data.primary_occupation === 'O' ? '其他职业类型的具体说明' : '无业状况的具体说明';
        errors.push(`请填写${explainType}`);
      }
      return {
        isValid: errors.length === 0,
        errors
      }
    }
    
    // 验证雇主或学校名称
    if (!data.present_employer_or_school_name) errors.push('请填写当前雇主或学校名称');
    
    // 验证地址信息
    if (!data.street_address) errors.push('请填写街道地址');
    if (!data.city) errors.push('请填写城市');
    if (!data.state) errors.push('请填写州/省');
    if (!data.zip_code) errors.push('请填写邮政编码');
    if (!data.country) errors.push('请选择国家');
    
    // 验证联系信息
    if (!data.phone_number) errors.push('请填写工作电话');
    
    // 验证开始日期
    const startDate = data.start_date || {};
    if (!startDate.year) errors.push('请填写开始工作/学习年份');
    if (!startDate.month) errors.push('请选择开始工作/学习月份');
    if (!startDate.day) errors.push('请选择开始工作/学习日期');
    
    // 验证收入信息
    if (data.has_income === undefined || data.has_income === null) {
      errors.push('请选择是否有收入');
    }
    if (data.has_income && !data.monthly_income) {
      errors.push('请填写月收入金额');
    }
    
    // 验证职责描述
    if (!data.describe_duties) errors.push('请描述工作职责或学习内容');
    
    return { isValid: errors.length === 0, errors, errorDetails };
  },
  // 工作教育历史验证
  work_education2: (data) => {
    const errors = [];
    const errorDetails = [];
    
    // 验证之前工作经历
    if (data.previously_employed) {
      const employments = data.previous_employments || [];
      if (employments.length === 0) {
        errors.push('请添加至少一个之前工作经历');
      } else {
        employments.forEach((employment, index) => {
          if (!employment.employer_name) errors.push(`工作经历${index + 1}: 请填写雇主名称`);
          if (!employment.job_title) errors.push(`工作经历${index + 1}: 请填写职位头衔`);
          if (!employment.employer_street_address1) errors.push(`工作经历${index + 1}: 请填写街道地址`);
          if (!employment.employer_city) errors.push(`工作经历${index + 1}: 请填写城市`);
          if (!employment.employer_state_province) errors.push(`工作经历${index + 1}: 请填写州/省`);
          if (!employment.employer_postal_code) errors.push(`工作经历${index + 1}: 请填写邮政编码`);
          if (!employment.employer_country) errors.push(`工作经历${index + 1}: 请选择国家`);
          if (!employment.employer_phone) errors.push(`工作经历${index + 1}: 请填写雇主电话`);
          if (!employment.supervisor_surname) errors.push(`工作经历${index + 1}: 请填写主管姓氏`);
          if (!employment.supervisor_given_name) errors.push(`工作经历${index + 1}: 请填写主管名字`);
          if (!employment.describe_duties) errors.push(`工作经历${index + 1}: 请填写工作职责描述`);
          
          // 验证工作日期
          const dateFrom = employment.employment_date_from || {};
          if (!dateFrom.year) errors.push(`工作经历${index + 1}: 请填写开始年份`);
          if (!dateFrom.month) errors.push(`工作经历${index + 1}: 请选择开始月份`);
          if (!dateFrom.day) errors.push(`工作经历${index + 1}: 请选择开始日期`);
          
          const dateTo = employment.employment_date_to || {};
          if (!dateTo.year) errors.push(`工作经历${index + 1}: 请填写结束年份`);
          if (!dateTo.month) errors.push(`工作经历${index + 1}: 请选择结束月份`);
          if (!dateTo.day) errors.push(`工作经历${index + 1}: 请选择结束日期`);

          // 日期先后（P0）
          const dFrom = mkDate(dateFrom.year, dateFrom.month, dateFrom.day);
          const dTo = mkDate(dateTo.year, dateTo.month, dateTo.day);
          if (dFrom && dTo && dTo < dFrom) {
            const msg = `工作经历${index + 1}: 结束日期不能早于开始日期`;
            errors.push(msg);
            errorDetails.push({ message: msg, anchor: `#employment_${index}_to_year` });
          }
        });
      }
    }
    
    // 验证其他教育经历
    if (data.other_education) {
      const educations = data.previous_educations || [];
      if (educations.length === 0) {
        errors.push('请添加至少一个其他教育经历');
      } else {
        educations.forEach((education, index) => {
          if (!education.school_name) errors.push(`教育经历${index + 1}: 请填写学校名称`);
          if (!education.course_of_study) errors.push(`教育经历${index + 1}: 请填写专业/课程`);
          if (!education.school_street_address1) errors.push(`教育经历${index + 1}: 请填写街道地址`);
          if (!education.school_city) errors.push(`教育经历${index + 1}: 请填写城市`);
          if (!education.school_state_province) errors.push(`教育经历${index + 1}: 请填写州/省`);
          if (!education.school_postal_code) errors.push(`教育经历${index + 1}: 请填写邮政编码`);
          if (!education.school_country) errors.push(`教育经历${index + 1}: 请选择国家`);
          
          // 验证就读日期
          const dateFrom = education.attendance_date_from || {};
          if (!dateFrom.year) errors.push(`教育经历${index + 1}: 请填写开始年份`);
          if (!dateFrom.month) errors.push(`教育经历${index + 1}: 请选择开始月份`);
          if (!dateFrom.day) errors.push(`教育经历${index + 1}: 请选择开始日期`);
          
          const dateTo = education.attendance_date_to || {};
          if (!dateTo.year) errors.push(`教育经历${index + 1}: 请填写结束年份`);
          if (!dateTo.month) errors.push(`教育经历${index + 1}: 请选择结束月份`);
          if (!dateTo.day) errors.push(`教育经历${index + 1}: 请选择结束日期`);

          // 日期先后（P0）
          const dFrom = mkDate(dateFrom.year, dateFrom.month, dateFrom.day);
          const dTo = mkDate(dateTo.year, dateTo.month, dateTo.day);
          if (dFrom && dTo && dTo < dFrom) {
            const msg = `教育经历${index + 1}: 结束日期不能早于开始日期`;
            errors.push(msg);
            errorDetails.push({ message: msg, anchor: `#education_${index}_to_year` });
          }
        });
      }
    }
    
    return {
      isValid: errors.length === 0,
      errors,
      errorDetails
    };
  },
  work_education3: (data) => {
    const errors = [];
    
    // 验证语言信息（至少需要一种语言）
    const languages = data.languages || [];
    if (languages.length === 0) {
      errors.push('请至少添加一种您能说的语言');
    } else {
      languages.forEach((language, index) => {
        if (!language.language_name) {
          errors.push(`语言${index + 1}: 请选择语言`);
        }
      });
    }
    
    // 验证访问过的国家（如果选择了去过其他国家）
    if (data.countries_visited_ind) {
      const countriesVisited = data.countries_visited || [];
      if (countriesVisited.length === 0) {
        errors.push('请至少添加一个访问过的国家');
      } else {
        countriesVisited.forEach((country, index) => {
          if (!country.country_code) {
            errors.push(`访问国家${index + 1}: 请选择国家`);
          }
        });
      }
    }
    
    // 验证组织信息（如果属于组织）
    if (data.organization_ind) {
      const organizations = data.organizations || [];
      if (organizations.length === 0) {
        errors.push('请至少添加一个组织');
      } else {
        organizations.forEach((org, index) => {
          if (!org.organization_name) {
            errors.push(`组织${index + 1}: 请填写组织名称`);
          }
        });
      }
    }
    
    // 验证特殊技能说明（如果有特殊技能）
    if (data.specialized_skills_ind && !data.specialized_skills_explanation) {
      errors.push('请说明您的特殊技能或培训');
    }
    
    // 验证军事服务信息（如果曾在军队服役）
    if (data.military_service_ind) {
      const militaryServices = data.military_services || [];
      if (militaryServices.length === 0) {
        errors.push('请至少添加一条服役记录');
      } else {
        militaryServices.forEach((service, index) => {
          if (!service.country_code) errors.push(`服役记录${index + 1}: 请选择服役国家`);
          if (!service.branch) errors.push(`服役记录${index + 1}: 请填写军种`);
          if (!service.rank) errors.push(`服役记录${index + 1}: 请填写军衔`);
          if (!service.specialty) errors.push(`服役记录${index + 1}: 请填写专业/职务`);
          
          // 验证服役开始日期
          const dateFrom = service.date_from || {};
          if (!dateFrom.year) errors.push(`服役记录${index + 1}: 请填写开始年份`);
          if (!dateFrom.month) errors.push(`服役记录${index + 1}: 请选择开始月份`);
          if (!dateFrom.day) errors.push(`服役记录${index + 1}: 请选择开始日期`);
          
          // 验证服役结束日期
          const dateTo = service.date_to || {};
          if (!dateTo.year) errors.push(`服役记录${index + 1}: 请填写结束年份`);
          if (!dateTo.month) errors.push(`服役记录${index + 1}: 请选择结束月份`);
          if (!dateTo.day) errors.push(`服役记录${index + 1}: 请选择结束日期`);
        });
      }
    }
    
    // 验证塔利班联系说明（如果有联系）
    if (data.taliban_ind && !data.taliban_explanation) {
      errors.push('请说明与塔利班的联系情况');
    }
    
    // 验证准军事组织说明（如果参与过）
    if (data.insurgent_org_ind && !data.insurgent_org_explanation) {
      errors.push('请说明参与的准军事组织情况');
    }
    
    return {
      isValid: errors.length === 0,
      errors
    };
  },
  part1: (data) => {
    const errors = [];
    const questions = ['disease', 'disorder', 'druguser'];
    
    // 获取问题的当前值
    const getQuestionValue = (key) => {
      const questionData = data[key];
      if (questionData && typeof questionData === 'object' && 'value' in questionData) {
        return questionData.value;
      }
      // 兼容旧的数据格式
      if (data[key] !== undefined) {
        return data[key];
      }
      // 如果数据未初始化，默认返回 false
      return false;
    };

    // 获取问题的解释文本
    const getQuestionExplanation = (key) => {
      const questionData = data[key];
      if (questionData && typeof questionData === 'object' && 'explanation' in questionData) {
        return questionData.explanation || '';
      }
      return '';
    };
    
    // 检查每个问题，如果选择"是"是否有说明
    questions.forEach(key => {
      const questionValue = getQuestionValue(key);
      const questionExplanation = getQuestionExplanation(key);
      
      // Part1的所有问题都已经有默认值false，所以不需要检查是否已回答
      
      // 如果选择了"是"，检查是否有解释
      if (questionValue === true && !questionExplanation) {
        const questionLabels = {
          'disease': '传染病健康状况',
          'disorder': '精神或身体疾病状况', 
          'druguser': '药物使用情况'
        };
        errors.push(`请详细说明您的${questionLabels[key]}`);
      }
    });
    
    return {
      isValid: errors.length === 0,
      errors
    };
  },
  part2: (data) => {
    const errors = [];
    const questions = [
      'arrested',
      'controlled_substances', 
      'prostitution',
      'money_laundering',
      'human_trafficking',
      'assisted_severe_trafficking',
      'human_trafficking_related'
    ];
    
    // 获取问题的当前值
    const getQuestionValue = (key) => {
      const questionData = data[key];
      if (questionData && typeof questionData === 'object' && 'value' in questionData) {
        return questionData.value;
      }
      // 兼容旧的数据格式
      if (data[key] !== undefined) {
        return data[key];
      }
      // 如果数据未初始化，默认返回 false
      return false;
    };

    // 获取问题的解释文本
    const getQuestionExplanation = (key) => {
      const questionData = data[key];
      if (questionData && typeof questionData === 'object' && 'explanation' in questionData) {
        return questionData.explanation || '';
      }
      return '';
    };
    
    // 检查每个问题是否已回答，以及如果选择"是"是否有说明
    questions.forEach(key => {
      const questionValue = getQuestionValue(key);
      const questionExplanation = getQuestionExplanation(key);
      
      // Part2的所有问题都已经有默认值false，所以不需要检查是否已回答
      
      // 如果选择了"是"，检查是否有解释
      if (questionValue === true && !questionExplanation) {
        errors.push(`请为相关问题提供详细说明`);
      }
    });
    
    return {
      isValid: errors.length === 0,
      errors
    };
  },
  part3: (data) => {
    const errors = [];
    const questions = [
      'illegal_activity',
      'terrorist_activity',
      'terrorist_support',
      'terrorist_org',
      'terrorist_rel',
      'genocide',
      'torture',
      'ex_violence',
      'child_soldier',
      'religious_freedom',
      'population_controls',
      'transplant'
    ];
    
    // 检查每个问题是否已回答
    questions.forEach(question => {
      const questionData = data[question];
      
      // 检查问题是否已回答
      if (questionData === undefined || questionData === null) {
        errors.push(`请回答关于"${question}"的问题`);
        return;
      }
      
      // 处理新的对象格式
      if (questionData && typeof questionData === 'object' && 'value' in questionData) {
        if (questionData.value === undefined || questionData.value === null) {
          errors.push(`请回答关于"${question}"的问题`);
        }
        // 如果选择了"是"，检查是否有解释
        if (questionData.value === true && !questionData.explanation) {
          errors.push(`请为"${question}"提供详细说明`);
        }
      } else {
        // 兼容旧格式
        if (questionData === undefined || questionData === null) {
          errors.push(`请回答关于"${question}"的问题`);
        }
      }
    });
    
    return {
      isValid: errors.length === 0,
      errors
    };
  },
  part4: (data) => ({ isValid: true, errors: [] }),
  part5: (data) => ({ isValid: true, errors: [] }),
  f1_school_info: (data) => {
    const errors = [];
    
    // 验证SEVIS ID
    if (!data.sevis_id) {
      errors.push('请填写SEVIS ID');
    } else if (data.sevis_id.length > 11) {
      errors.push('SEVIS ID不能超过11个字符');
    }
    
    // 验证学校名称
    if (!data.school_name) {
      errors.push('请填写学校名称');
    } else if (data.school_name.length > 75) {
      errors.push('学校名称不能超过75个字符');
    }
    
    // 验证学习课程
    if (!data.course_of_study) {
      errors.push('请填写学习课程');
    } else if (data.course_of_study.length > 66) {
      errors.push('学习课程不能超过66个字符');
    }
    
    // 验证地址信息
    if (!data.school_street_address1) {
      errors.push('请填写学校街道地址');
    } else if (data.school_street_address1.length > 40) {
      errors.push('街道地址不能超过40个字符');
    }
    
    if (data.school_street_address2 && data.school_street_address2.length > 40) {
      errors.push('街道地址第二行不能超过40个字符');
    }
    
    if (!data.school_city) {
      errors.push('请填写学校所在城市');
    } else if (data.school_city.length > 20) {
      errors.push('城市不能超过20个字符');
    }
    
    if (!data.school_state) {
      errors.push('请选择学校所在州');
    }
    
    if (!data.school_zip_code) {
      errors.push('请填写学校邮政编码');
    } else {
      // 验证邮政编码格式
      const zipCodeRegex = /^\d{5}(-\d{4})?$/;
      if (!zipCodeRegex.test(data.school_zip_code)) {
        errors.push('请输入有效的美国邮政编码格式（如：12345 或 12345-6789）');
      }
    }
    
    return { isValid: errors.length === 0, errors };
  },
  f1_additional_contacts: (data) => {
    const errors = [];
    
    const contacts = data.additional_contacts || [];
    
    // 验证至少需要两个联系人
    if (contacts.length < 2) {
      errors.push('F1签证需要至少两个额外联系人');
    }
    
    // 验证每个联系人
    contacts.forEach((contact, index) => {
      // 验证必填字段
      if (!contact.surnames) {
        errors.push(`联系人 #${index + 1}: 请填写姓氏`);
      }
      if (!contact.given_name) {
        errors.push(`联系人 #${index + 1}: 请填写名字`);
      }
      if (!contact.street_address_line1) {
        errors.push(`联系人 #${index + 1}: 请填写街道地址`);
      }
      if (!contact.city) {
        errors.push(`联系人 #${index + 1}: 请填写城市`);
      }
      if (!contact.country) {
        errors.push(`联系人 #${index + 1}: 请选择国家`);
      }
      
      // 验证至少有一个联系方式
      if (!contact.telephone_na && !contact.telephone && !contact.email_na && !contact.email) {
        errors.push(`联系人 #${index + 1}: 请至少填写电话号码或电子邮件地址`);
      }
      
      // 验证字符长度
      if (contact.surnames && contact.surnames.length > 33) {
        errors.push(`联系人 #${index + 1}: 姓氏不能超过33个字符`);
      }
      if (contact.given_name && contact.given_name.length > 33) {
        errors.push(`联系人 #${index + 1}: 名字不能超过33个字符`);
      }
      if (contact.street_address_line1 && contact.street_address_line1.length > 40) {
        errors.push(`联系人 #${index + 1}: 街道地址不能超过40个字符`);
      }
      if (contact.street_address_line2 && contact.street_address_line2.length > 40) {
        errors.push(`联系人 #${index + 1}: 街道地址第二行不能超过40个字符`);
      }
      if (contact.city && contact.city.length > 20) {
        errors.push(`联系人 #${index + 1}: 城市不能超过20个字符`);
      }
      if (contact.state_province && contact.state_province.length > 20) {
        errors.push(`联系人 #${index + 1}: 州/省份不能超过20个字符`);
      }
      if (contact.postal_code && contact.postal_code.length > 10) {
        errors.push(`联系人 #${index + 1}: 邮政编码不能超过10个字符`);
      }
      if (contact.telephone && contact.telephone.length > 15) {
        errors.push(`联系人 #${index + 1}: 电话号码不能超过15个字符`);
      }
      if (contact.email && contact.email.length > 50) {
        errors.push(`联系人 #${index + 1}: 电子邮件不能超过50个字符`);
      }
    });
    
    return { isValid: errors.length === 0, errors };
  },

  // F2签证SEVIS信息验证
  f2_sevis_info: (data) => {
    const errors = [];
    
    // 验证SEVIS ID格式
    if (data.sevis_id) {
      const sevisPattern = /^N\d{10}$/;
      if (!sevisPattern.test(data.sevis_id)) {
        errors.push('SEVIS ID格式不正确，请使用N + 10位数字的格式');
      }
    } else {
      errors.push('请填写SEVIS ID');
    }
    
    // 验证主申请人SEVIS ID格式
    if (data.principal_sevis_id) {
      const sevisPattern = /^N\d{10}$/;
      if (!sevisPattern.test(data.principal_sevis_id)) {
        errors.push('主申请人SEVIS ID格式不正确，请使用N + 10位数字的格式');
      }
    } else {
      errors.push('请填写主申请人SEVIS ID');
    }
    
    return { isValid: errors.length === 0, errors };
  }
};

// 获取表单状态
export const getFormStatus = (pageId) => {
  const isVisited = formDataStorage.isPageVisited(pageId);
  
  if (!isVisited) {
    return 'default'; // 未访问
  }
  
  const formData = formDataStorage.loadFormData(pageId);
  const validator = formValidators[pageId];
  
  if (validator) {
    const validation = validator(formData);
    return validation.isValid ? 'completed' : 'incomplete';
  }
  
  return 'incomplete';
};

// 获取所有表单状态
export const getAllFormStatuses = () => {
  const statuses = {};
  
  // 获取当前签证类型
  const getCurrentVisaType = () => {
    const travelData = formDataStorage.loadFormData('travel');
    if (travelData?.purpose?.length > 0) {
      const firstPurpose = travelData.purpose[0];
      if (firstPurpose.sub_type && firstPurpose.sub_type.startsWith('F1-')) {
        return 'F';
      } else if (firstPurpose.sub_type && firstPurpose.sub_type.startsWith('F2-')) {
        return 'F2';
      }
    }
    return null;
  };
  
  // 根据签证类型确定需要验证的表单页面
  const getFormPagesForValidation = (visaType) => {
    // 直接定义页面列表，避免循环依赖
    const basePages = [
      'personal_1', 'personal_2', 'travel', 'travel_companions_info',
      'previous_US_travel_info', 'address_phone', 'passport_visa',
      'us_contact', 'family_info', 'work_education', 'work_education2',
      'work_education3', 'part1', 'part2', 'part3', 'part4', 'part5'
    ];
    
    // 根据签证类型添加特定页面
    if (visaType === 'F') {
      return [...basePages, 'f1_additional_contacts', 'f1_school_info'];
    }
    if (visaType === 'F2') {
      return [...basePages, 'f2_sevis_info'];
    }
    
    return basePages;
  };
  
  const visaType = getCurrentVisaType();
  const formPages = getFormPagesForValidation(visaType);
  
  formPages.forEach(pageId => {
    const isVisited = formDataStorage.isPageVisited(pageId);
    const formData = formDataStorage.loadFormData(pageId);
    
    if (isVisited && formData && Object.keys(formData).length > 0) {
      // 检查是否有验证器
      const validator = formValidators[pageId];
      if (validator) {
        const result = validator(formData);
        // 对于旅行信息表单，如果只是部分字段缺失，标记为partial而不是incomplete
        if (pageId === 'travel' && !result.isValid && result.errors.length <= 3) {
          statuses[pageId] = 'partial';
        } else {
          statuses[pageId] = result.isValid ? 'completed' : 'incomplete';
        }
      } else {
        // 如果没有验证器，只要有数据就认为完成
        statuses[pageId] = 'completed';
      }
    } else if (isVisited) {
      // 如果页面已访问但数据为空，检查是否有初始字段定义
      const initialFields = formDataStorage.loadFormData(pageId);
      if (initialFields && Object.keys(initialFields).length > 0) {
        // 如果有初始字段定义，标记为partial而不是incomplete
        statuses[pageId] = 'partial';
      } else {
        statuses[pageId] = 'incomplete';
      }
    } else {
      statuses[pageId] = 'default';
    }
  });
  
  return statuses;
}

// 导出验证器（不重复导出 getAllFormStatuses）
// 保留命名导出 getFormStatus 与 getAllFormStatuses
